$(document).ready(function () {
  
  $(document).on('click','.mobile_filter',function(){
    $('body').addClass('active_mobile_filter');
  });
  $(document).on('click','.mobile_filter_close',function(){
    $('body').removeClass('active_mobile_filter');
  });
  

  $(".single-slider .slide-list").slick({
    dots: false,
    arrows: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 300,
    slidesToShow: 1,
  });

  $(".product_gallery_nav").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".product-list .products-slider-slick").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".reviewBox").slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$(".tab-container").each(function (k, v) {
  $(v).find(".tab_content:first").show();
});

/* if in tab mode */
$("ul.tabs li").click(function () {
  var parent = $(this).parents(".tab-container");

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent)
    .find("#" + activeTab)
    .fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent)
    .find(".tab_drawer_heading[rel^='" + activeTab + "']")
    .addClass("d_active");

  $(".products-slider-slick").slick("refresh");
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function () {
  var parent = $(this).parents(".tab-container");

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent)
    .find("#" + d_activeTab)
    .fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent)
    .find("ul.tabs li[rel^='" + d_activeTab + "']")
    .addClass("active");

  $(".products-slider-slick").slick("refresh");
});

/* Extra class "tab_last"
   to add border to right side
   of last tab */
$("ul.tabs li").last().addClass("tab_last");

// product page description tab

document.addEventListener(
  "DOMContentLoaded",
  function () {
    $("ul.tabs").each(function () {
      var active,
        content,
        links = $(this).find("a");
      active = links.first().addClass("active");
      content = $(active.attr("href"));
      links.not(":first").each(function () {
        $($(this).attr("href")).hide();
      });
      $(this)
        .find("a")
        .click(function (e) {
          active.removeClass("active");
          content.hide();
          active = $(this);
          content = $($(this).attr("href"));
          active.addClass("active");
          content.show();
          return false;
        });
    });
  },
  false
);

$(document).ready(function () {
  $(".js-show-filter").click(function () {
    $(this).toggleClass("highlighted");
  });
});
$(document).ready(function () {
  $(".openreview").click(function () {
    //$(this).toggleClass("highlighted");
    $('.tabs li a.active').removeClass('active');
    $('#tabmyreviews').addClass('active');
    $('#tab-description').hide();
    $('#tab-review').show();
    $('html, body').animate({
        scrollTop: $("#tab-review").offset().top
    }, 2000);
  });
});
$(document).ready(function () {
  $(".play-pause-button-3").click(function () {        
    const video = document.getElementById("myVideo");
    var isplay = $('#myVideo').data('status');
    if(isplay == 'play')
    {
      video.pause();
      $('.pause-state').attr("hidden",false);
      $('.play-state').attr("hidden",true);
      $('#myVideo').data('status', 'pause');
    }  
    else
    {
      video.play();
      $('.pause-state').attr("hidden",true);
      $('.play-state').attr("hidden",false);
      $('#myVideo').data('status', 'play');
    }
  });  
});